import { PredictionSummaryData } from "../../types";
import InsightSection from "./insightSection";

/**
 * Props for the Historical Insights tab.
 */
interface HistoricalInsightsTabProps {
  /** Evaluation engine payload containing mined insights. */
  data: PredictionSummaryData;
}

/**
 * Historical Insights tab with grey-headed light content cards for each section.
 *
 * @param props.data - Prediction summary payload
 */
const HistoricalInsightsTab = (props: HistoricalInsightsTabProps) => {
  const minedInsight = props.data.mined_insight;
  const drugForm = minedInsight?.drug_form;
  const drugPlanRule = minedInsight?.drug_plan_rule ?? [];

  const hasContent =
    drugPlanRule.length > 0 ||
    (drugForm?.required_labs?.length ?? 0) > 0 ||
    (drugForm?.denial_reasons?.length ?? 0) > 0 ||
    (drugForm?.step_therapy?.length ?? 0) > 0;

  if (!hasContent) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-center text-small text-primaryGray-6">
          No historical insights available.
        </div>
      </div>
    );
  }

  return (
    <div className="prediction-summary-modal__historical flex flex-col gap-5 p-1 mb-2">
      <InsightSection title="Drug Plan Rule" items={drugPlanRule} />
      <InsightSection
        title="Required Labs / Docs"
        items={drugForm?.required_labs ?? []}
      />
      <InsightSection
        title="Common Denial Reasons"
        items={drugForm?.denial_reasons ?? []}
        variant="danger"
      />
      <InsightSection
        title="Step Therapy Requirement"
        items={drugForm?.step_therapy ?? []}
        variant="warning"
      />
    </div>
  );
};

export default HistoricalInsightsTab;
